// client/src/pages/admin/AdminDashboard.js
import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import adminService from '../../services/adminService.js';

export default function AdminDashboard() {
  const [data, setData] = useState(null);

  useEffect(() => {
    adminService.getDashboard().then(setData).catch(() => {});
  }, []);

  const adminLinks = [
    { to: '/admin/templates', label: 'Templates', icon: '🎨' },
    { to: '/admin/field-definitions', label: 'Field Definitions', icon: '📝' },
    { to: '/admin/music', label: 'Music', icon: '🎵' },
    { to: '/admin/stories', label: 'Stories', icon: '📖' },
    { to: '/admin/subcategories', label: 'Story Subcategories', icon: '📑' },
    { to: '/admin/categories', label: 'Categories', icon: '📂' },
    { to: '/admin/settings', label: 'Settings', icon: '⚙️' },
    { to: '/admin/links', label: 'Links', icon: '🔗' },
    { to: '/admin/analytics', label: 'Analytics', icon: '📊' },
    { to: '/admin/users', label: 'Users', icon: '👥' },
    { to: '/admin/user-types', label: 'Plans & Tiers', icon: '💎' },
    { to: '/admin/sending-domains', label: 'Sending Domains', icon: '📤' },
    { to: '/admin/gifts', label: 'Gift Management', icon: '🎁' },
    { to: '/admin/gift-email-templates', label: 'Gift Email Templates', icon: '✉️' },
    { to: '/admin/notification-email-templates', label: 'Email Templates', icon: '📧' },
    { to: '/admin/unsubscribe-templates', label: 'Unsubscribe Footers', icon: '🚫' },
    { to: '/admin/marketing', label: 'Marketing Campaigns', icon: '📣' },
  ];

  return (
    <div className="max-w-6xl mx-auto px-4 py-8">
      <h1 className="font-display text-3xl text-gold mb-8">Admin Dashboard</h1>

      {/* Stats */}
      {data && (
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-8">
          <div className="bg-royal-800/40 border border-royal-600 rounded-xl p-4 text-center">
            <p className="text-2xl font-bold text-gold">{data.users?.total || 0}</p>
            <p className="text-royal-400 text-sm">Total Users</p>
          </div>
          <div className="bg-royal-800/40 border border-royal-600 rounded-xl p-4 text-center">
            <p className="text-2xl font-bold text-green-400">{data.users?.recent || 0}</p>
            <p className="text-royal-400 text-sm">New (30 days)</p>
          </div>
          <div className="bg-royal-800/40 border border-royal-600 rounded-xl p-4 text-center">
            <p className="text-2xl font-bold text-blue-400">{data.cards?.total || 0}</p>
            <p className="text-royal-400 text-sm">Total Cards</p>
          </div>
          <div className="bg-royal-800/40 border border-royal-600 rounded-xl p-4 text-center">
            <p className="text-2xl font-bold text-valentine-pink">{data.cards?.sent || 0}</p>
            <p className="text-royal-400 text-sm">Cards Sent</p>
          </div>
        </div>
      )}

      {/* Quick Links */}
      <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
        {adminLinks.map((link) => (
          <Link
            key={link.to}
            to={link.to}
            className="bg-royal-800/40 border border-royal-600 rounded-xl p-6 text-center hover:border-gold/50 transition-colors"
          >
            <span className="text-3xl block mb-2">{link.icon}</span>
            <span className="text-white font-semibold">{link.label}</span>
          </Link>
        ))}
      </div>
    </div>
  );
}